import { NodeLabelDrawingFunction } from 'sigma/rendering';

export const makeDrawNodeLabel = (
  labelOutlineColor: string,
  preview: boolean = false,
): NodeLabelDrawingFunction =>
  function drawNodeLabel(context, data, settings) {
    if (!data.label) return;

    context.strokeStyle = labelOutlineColor;
    context.lineWidth = preview ? 2 : 3;

    const size = data.highlighted ? 16 : settings.labelSize,
      font = settings.labelFont,
      weight = settings.labelWeight,
      color = settings.labelColor.attribute
        ? data[settings.labelColor.attribute] ||
          settings.labelColor.color ||
          '#000'
        : settings.labelColor.color;
    context.fillStyle = color;
    context.font = `${weight} ${size}px ${font}`;

    context.textAlign = 'center';
    context.textBaseline = 'middle';

    context.strokeText(data.label!, data.x, data.y);
    context.fillText(data.label, data.x, data.y);
  };

export const makeDrawNodeHover = (
  labelOutlineColor: string,
): NodeLabelDrawingFunction => {
  const drawNodeLabel = makeDrawNodeLabel(labelOutlineColor);

  return function drawNodeHover(context, data, settings) {
    if (!data.label) return;

    const size = settings.labelSize,
      font = settings.labelFont,
      weight = settings.labelWeight;
    context.font = ''
      .concat(weight, ' ')
      .concat(size.toString(), 'px ')
      .concat(font);

    // Then we draw the label background
    context.fillStyle = '#FFF';
    context.shadowOffsetX = 0;
    context.shadowOffsetY = 0;
    context.shadowBlur = 8;
    context.shadowColor = '#000';
    const PADDING = 2;

    context.beginPath();
    context.arc(data.x, data.y, data.size + PADDING, 0, Math.PI * 2);
    context.closePath();
    context.fill();

    context.fillStyle = data.color;
    context.shadowOffsetX = 0;
    context.shadowOffsetY = 0;
    context.shadowBlur = 0;
    context.beginPath();
    context.arc(data.x, data.y, data.size, 0, Math.PI * 2);
    context.closePath();
    context.fill();

    context.shadowOffsetX = 0;
    context.shadowOffsetY = 0;
    context.shadowBlur = 0;

    drawNodeLabel(context, data, settings);
  };
};
